import { statusSchema, type Alert, type Status } from "@/schemas";
import { filteredArray } from "@/schemas/utils";

import { QueryKeys } from "../../query-keys";
import { importEntities } from "../index";

/**
 * Import statuses to the global cache.
 *
 * In each status, there are three possible statuses to import:
 *  - status itself
 *  - "quote" status
 *  - "reblog" status
 *
 * @param statuses - array of Statuses
 */
function importStatuses(statuses: Status[]) {
  const statusesWithoutAds = statuses.filter(
    (status) => !status.id.endsWith("-ad"),
  );

  const statusesToImport = statusesWithoutAds
    .flatMap((status) => [status, status.reblog, status.quote])
    .filter(Boolean);

  const parsedResult = filteredArray(statusSchema).safeParse(statusesToImport);
  if (parsedResult.success) {
    importEntities(QueryKeys.statuses.global, parsedResult.data);
  }
}

/**
 * Import statuses to the global cache from a list of Alerts.
 *
 * In each status, there are three possible statuses to import:
 *  - status itself
 *  - "quote" status
 *  - "reblog" status
 *
 * @param alerts - array of Alerts
 */
function importStatusesFromAlerts(alerts: Alert[]) {
  const statusesToImport = alerts
    .flatMap((alert) => {
      const statuses = [];
      if ("status" in alert) {
        statuses.push(alert.status);
        statuses.push(alert.status?.reblog);
        statuses.push(alert.status?.quote);
      }

      return statuses;
    })
    .filter(Boolean);

  const parsedResult = filteredArray(statusSchema).safeParse(statusesToImport);
  if (parsedResult.success) {
    importEntities(QueryKeys.statuses.global, parsedResult.data);
  }
}

export { importStatuses, importStatusesFromAlerts };
